<template>
  <section>
    <cover-image :src="'static/bg-about.jpg'" :title="$t('pages.about.title')" :subtitle="''"></cover-image>
    <div class="container">
      <div class="row content">
        <div class="col-12" v-html="$t('pages.about.content')">
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CoverImage from '@/components/ui/CoverImage'

export default {
  name: 'AboutView',
  components: { CoverImage },
  metaInfo() {
    return {
      title: this.title
    }
  },
  data() {
    return {
      title: this.$t('navigation.about')
    }
  },
  props: {
    language: String
  }
}
</script>

<style lang="scss" scoped>
  @import "~styles/_vars.scss";

  .content {
    padding: 1rem 0 2rem 0;
  }
</style>



// WEBPACK FOOTER //
// AboutView.vue?3000c816